const modeloTareaEnumerators = {
  tipoVisualizacion: ['Pasos', 'Estandar', 'Checklist', 'Procedimiento'],
  prioridad: ['Baja', 'Media', 'Alta'],
  tipoProcedimiento: ['Evaluacion', 'Encuesta', 'Certificacion'],
  clasificacion: ['operativa', 'mantenimiento', 'incidente', 'investigacionIncidente', 'inspeccion', 'observacion'],
};

export default modeloTareaEnumerators;
